import React, {
    Fragment,
    useRef,
    useState,
} from 'react';
import { Dialog, Transition } from '@headlessui/react';
import {TfiClose} from "react-icons/tfi";


export const DeleteTokenModal = ({ show, setShow, token, deleteToken }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const cancelButtonRef = useRef(null);

    return (
        <Transition.Root show={show} as={Fragment}>
            <Dialog
                className="relative z-20"
                initialFocus={cancelButtonRef}
                onClose={setShow}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-60 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className='flex max-w-2xl flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative' >
                                {showDeleteModal && <DeleteTokenModal
                                    show={showDeleteModal}
                                    setShow={setShowDeleteModal}
                                    token={token}
                                /> }

                                <button
                                    type='button'
                                    className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                                    onClick={() => setShow(false)}
                                    ref={cancelButtonRef}
                                >
                                    <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                                </button>


                                <div className='flex w-full h-full'>
                                    <div className={' flex flex-col w-full'}>
                                        <Dialog.Title
                                            as='h3'
                                            className='pt-8 px-8  font-bold text-2xl leading-6 text-gray-900-'>
                                            API-Schlüssel löschen
                                        </Dialog.Title>
                                        <div className='p-8 flex text-sm flex-col flex-1 overflow-y-auto'>
                                            <p >Das Löschen des API-Schlüssels führt dazu, dass alle Anwendungen, die auf diesen Schlüssel zugreifen, den Zugriff auf die API verlieren. Dies kann zu Störungen im Betrieb, Datenverlust oder dem Ausfall von Diensten führen. Stellen Sie sicher, dass Sie alle betroffenen Integrationen aktualisieren oder einen neuen API-Schlüssel generieren, bevor Sie diesen Schritt ausführen.</p>
                                            <p className='mt-4 text-red font-bold'>{`Wollen Sie den Schlüssel "${token.name}" wirklch löschen?`}</p>
                                        </div>
                                        <div className="p-8 pt-0 sm:flex-row-reverse flex w-full flex-col-reverse gap-4">
                                            <button
                                                type="button"
                                                className={"text-center truncate items-center rounded-md bg-white text-red  border-red border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold"}
                                                onClick={() => {
                                                        deleteToken(token.id);
                                                        setShow(false);
                                                    }
                                                }
                                            >
                                                Schlüssel löschen
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>


                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
